import containerItem from "../type/item/container.js";
import compositionItem from "../type/item/composition.js";
import basePage from "./basePage.js";
import store from '../config.js'
import * as namespaceStore from "../namespaceStore.js"

const live_page = class extends basePage {
    Background = [];//list class containerItem
    ShotButton = [];//list class containerItem
    HomeButton = [];//list class containerItem
    Foreground = [];//list class containerItem
    Name = "Live";
    constructor(args = {}) {
        super(args);
        this.Background = args.background ? args.background : [];
        this.ShotButton = args.shotButton ? args.shotButton : [];
        this.HomeButton = args.homeButton ? args.homeButton : [];
        this.Foreground = args.foreground ? args.foreground : [];
    }
    checkIsComplete(result = {isComplete: true, requiredBeforeSave: false, missingElements: []}) {
        result = super.checkIsComplete(result);
        if (this.ShotButton.length == 0) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push(`Page: ${this.Name} - Bouton prise photo`);
        }
        if (store.getters[namespaceStore.THEME + "/compositions"] == null || store.getters[namespaceStore.THEME + "/compositions"].length == 0) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push(`Aucune composition selectionnée`);
        }
        return result;
    }
    static get _Compositions() {
        return { 
            tooltip: "Retour camera par composition, un seul retour de composition sera affiché en fonction de la composition selectionnée par le client.",
            property: "Live",
            objectType: "CompositionItem",
            jsType: "Array",
            text: "Retour camera",
            description: "Le retour camera",
            constructor: compositionItem
        };
    }
    static variableOfInstance() {
        return [
            {property: "Background", construct: containerItem, jsType: "Array"},
            ...super.variableOfInstance(),
            {property: "HomeButton", construct: containerItem, jsType: "Array"},
            {property: "ShotButton", construct: containerItem, jsType: "Array"},
            {property: "Foreground", construct: containerItem, jsType: "Array"},
        ];
    }
    onShow() {
        const composition = store.getters[namespaceStore.THEME + "/compositions"];
        if (composition && composition.length > 0) {
            let showIndex = [];
            composition.forEach((c, index) => {
                if (c.Live.Show == true) {
                    showIndex.push(index);
                }
            });
            if (showIndex.length > 1) {
                showIndex.forEach((indexComposition, index) => {
                    if (index != 0) {
                        composition[indexComposition].Live.Show = false;
                    }
                });
            }
            else {
                composition[0].Live.Show = true;
            }
        }
        return null;
    }
    getPropertiesDescription() {
        return [
            ...super.getPropertiesDescription(),
            { iconSVG: "backgroundIcon", name: "Background", text: "Fond", description: "Éléments de fond de la page", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { iconSVG: "backIcon", name: "HomeButton", text: "Bouton retour", description: "Bouton pour revenir à la page d'acceuil", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { iconSVG: "validateIcon", name: "ShotButton", text: "Bouton prise photo", description: "Bouton pour prendre la photo", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { name: "Foreground", text: "Avant plan", description: "Éléments en avant plan de la page", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
        ]
    }
}
export default live_page;